(function () {
  var DURATION_MS = 15 * 60 * 1000;
  var STORAGE_KEY = 'aurora_cart_reserve_until';

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  /**
   * Reads (or creates) the target timestamp for the current reservation
   * window, persisted in localStorage so it keeps counting down across
   * drawer opens/closes and cart re-renders instead of resetting to 15:00
   * every time.
   */
  function getTargetTime() {
    var stored = null;
    try {
      stored = window.localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      /* localStorage unavailable (private mode, blocked, etc.) */
    }

    var now = Date.now();
    var target = stored ? parseInt(stored, 10) : NaN;

    if (!target || isNaN(target) || target <= now) {
      target = now + DURATION_MS;
      try {
        window.localStorage.setItem(STORAGE_KEY, String(target));
      } catch (e) {}
    }
    return target;
  }

  function initTimer(el) {
    var strongEl = el.querySelector('[data-aurora-cart-reserve-timer]');
    if (!strongEl) return;

    var target = getTargetTime();

    function tick() {
      var now = Date.now();
      var diff = target - now;

      if (diff <= 0) {
        target = now + DURATION_MS;
        try {
          window.localStorage.setItem(STORAGE_KEY, String(target));
        } catch (e) {}
        diff = target - now;
      }

      var totalSeconds = Math.max(0, Math.floor(diff / 1000));
      var minutes = Math.floor(totalSeconds / 60);
      var seconds = totalSeconds % 60;

      // Se reaplica en cada tick (no solo al llegar a 0) porque el carrito
      // puede volver a renderizar este bloque con el "15:00" por defecto del
      // servidor (ej. al agregar/quitar un producto), y así se autocorrige
      // en menos de 1 segundo — mismo patrón que el contador de despacho.
      strongEl.textContent = pad(minutes) + ':' + pad(seconds);
    }

    tick();
    setInterval(tick, 1000);
  }

  function init() {
    var els = document.querySelectorAll('[data-aurora-cart-reserve]');
    els.forEach(function (el) {
      if (el.__auroraCartReserveInit) return;
      el.__auroraCartReserveInit = true;
      initTimer(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
